import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import get from 'lodash/get'

import useRailsEnv from 'hooks/useRailsEnv'

const AccountVerificationBanner = () => {
  const { pathname } = useLocation()
  const { embedded } = useRailsEnv()
  const currentUser = useSelector(({ auth }) => auth.currentUser)
  const pathMatches = pathname.match(/\/my\/(listings|inbox)/)
  const verificationStatus = get(
    currentUser,
    'payout_account.verification_status',
  )
  const shouldShow = pathMatches && verificationStatus === 'unverified'
  if (!shouldShow) return null

  // The account pages sit outside the stand-alone editor, so embedded
  // webviews verify via the editor's own Payouts section instead — and
  // hide the banner entirely where there's no editor to retarget to
  const editorListingId = embedded
    ? pathname.match(/\/my\/listings\/(\d+)\/edit(\/|$)/)?.[1]
    : undefined

  if (embedded && !editorListingId) return null

  return (
    <div className="alerts-wrapper">
      <div className="container-flexible alerts alert-warning">
        <div className="row">
          <div className="col-md-12 alert alert-dismissible" role="alert">
            <span>
              Stripe requires additional information to verify your payout
              account.{' '}
              {editorListingId ? (
                <Link to={`/my/listings/${editorListingId}/edit/payouts`}>
                  Verify your account now.
                </Link>
              ) : (
                <a href="/my/account/payout-account">
                  Verify your account now.
                </a>
              )}
            </span>
            <button
              className="close"
              aria-label="Close"
              data-dismiss="alert"
              type="button"
            >
              <span className="icon icon-close" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountVerificationBanner
